module.exports = __webpack_public_path__ + "static/media/c5.2eedd4fb.jpg";